/* eslint no-unused-vars: "off" */
import Dict, {
  transformDict,
  fetchDict,
  setDict,
  getDict,
  dictKey,
  toDictLabel,
} from "./dict";
export { transformDict, fetchDict, setDict, getDict, dictKey, toDictLabel };

// 设置字典文本数据，支持多层级书写。格式：[{ value: 'xx', label: 'xxx' }]
// 使用过滤器 toDictLabel 显示对应字典标签文本
// 建议使用 transformDict, fetchDict 2个方法来设置字典数据

Dict({
  // 新闻类型
  sysNewsType: transformDict(`1: 公司动态, 3: 行业新闻`),
});



// WEBPACK FOOTER //
// ./src/filter/dict/index.js